<template>
  <collapsible-widget title="ANALIZA DOSTĘPU DO ŁĄCZY SZEROKOPASMOWYCH" :accordion="accordion" :default-expanded="true">
    <b-form class="p-2 pt-4 pb-4">
      <b-form-row>
        <b-col>
          <b-alert variant="danger" :show="bufforIsEmpty || bufforValueIsInvalid"><strong>Uwaga.</strong> Formularz zawiera błędy.</b-alert>
        </b-col>
      </b-form-row>
      <b-form-row v-if="bufforIsEmpty">
        <b-col offset="4" cols="8">
          <small class="text-danger">Należy określic bufor.</small>
        </b-col>
      </b-form-row>
      <b-form-row v-if="bufforValueIsInvalid">
        <b-col offset="4" cols="8">
          <small class="text-danger">Należy podać wartość od 0 do 1000.</small>
        </b-col>
      </b-form-row>
      <b-form-row>
        <b-col cols="4">
          <label>Bufor</label>
        </b-col>
        <b-col cols="8">
          <b-form-input id="buffor" v-model.number="buffor" placeholder="Wpisz" type="number" max="1000" step="1" min="0" :state="bufforIsEmpty || bufforValueIsInvalid ? false : null"></b-form-input>
        </b-col>
      </b-form-row>
      <b-form-row class="pt-2">
        <b-col cols>
          <b-btn class="col-md-12" variant="primary" @click="generateReport" size="sm">Generuj raport</b-btn>
        </b-col>
        <b-col cols>
          <b-btn class="col-md-12" variant="outline-secondary" @click="cancel" size="sm">Anuluj</b-btn>
        </b-col>
      </b-form-row>
    </b-form>
  </collapsible-widget>
</template>

<script>
import CollapsibleWidget from './CollapsibleWidget';
import { CONNECTION_ANALYSIS_TOGGLE } from '../store/mutations.type';
import { CONNECTION_GENERATE_REPORT } from '../store/actions.type';

export default {
  props: {
    accordion: {
      type: String,
      default: 'panel'
    }
  },
  components: {
    CollapsibleWidget
  },
  data() {
    return {
      buffor: null,
      bufforIsEmpty: false,
      bufforValueIsInvalid: false
    }
  },
  methods: {
    async generateReport() {
      this.bufforIsEmpty = this.buffor === null || this.buffor === "";
      this.bufforValueIsInvalid = !this.bufforIsEmpty && (this.buffor < 0 || this.buffor > 1000);
      if (!this.bufforIsEmpty && !this.bufforValueIsInvalid) {
        this.$notify({ clean: true });
        
        this.$notify({
          type: "info",
          title: "Informacja.",
          text: "Raport zostanie automatycznie pobrany po jego wygenerowaniu.",
          duration: 2000
        });

        await this.$store.dispatch(CONNECTION_GENERATE_REPORT, this.buffor);
      }
    },
    cancel() {
      this.$store.commit(CONNECTION_ANALYSIS_TOGGLE);
    }
  }
}
</script>
